module.exports = __webpack_public_path__ + "img/Павлодар облысы.546e3db3.png";